import { render, staticRenderFns } from "./MedicalLabelDrClinique.vue?vue&type=template&id=51212350&"
import script from "./MedicalLabelDrClinique.vue?vue&type=script&lang=js&"
export * from "./MedicalLabelDrClinique.vue?vue&type=script&lang=js&"
import style0 from "./MedicalLabelDrClinique.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports